import { createFileRoute } from "@tanstack/react-router";

import { LineSidebar } from "@/components/ManageLines/LineDetailSidebar";

export const Route = createFileRoute("/gym/$venueUuid/settings/lines/create")({
  component: () => <LineSidebar uuid={null} />,
});
